module.exports = __webpack_public_path__ + "media/images/coming-soon/Coming Soon-184d5e6d7c2483e67de5b1339916b7f5.png";